import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IProfessionalProfile } from 'app/interfaces/professionalprofile.interface';
import { UserService } from 'app/services/user.service';
import { ZkuService } from 'app/services/zku.service';
import { UnleashService } from 'shared/unleash/unleash.service';

import { myAccountPages } from '../../my-account.pages';

@Component({
	selector: 'app-my-account-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss'],
})
export class MyAccountMenuComponent implements OnInit {
	currentPath: string;
	userIsPremium: boolean;
	isUserActive;
	myAccountPages = myAccountPages;

	@Input() page: {
		name: string;
		title: string;
		description: string;
		url: string;
	};
	@Input() user: IProfessionalProfile;
	@Output() selected = new EventEmitter<string>();

	constructor(
		public zkuService: ZkuService,
		private router: Router,
		private unleashService: UnleashService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.userService.checkSubscriptionAndContactTiers().then((user) => {
			this.userIsPremium = user.hasActiveSubscription;
		});
		this.userService.getProfileData().then((user) => {
			this.isUserActive = user.active;
		});
		this.currentPath = this.router.url.replace('/account/', '');

		const onsiteSessionsToggle =
			this.unleashService.isEnabled('onsite-sessions');
		if (!onsiteSessionsToggle) {
			this.myAccountPages = this.myAccountPages.filter(
				(page) => page.path !== 'onsite-sessions'
			);
		}
	}

	changePage(pageName: string): void {
		this.selected.emit(pageName);
	}

	openProfilePage(): void {
		window.open(this.user.profileUrl, '_blank');
	}
}
